import { DialogActions } from "@mui/material";
import React from "react";
import CustomButton from "./../customButton/index";

const DialogFooter = ({ handleBtn, handleClose, btnLabel }) => {
  return (
    <DialogActions>
      {handleClose && (
        <CustomButton
          btnLabel={"Close"}
          handlePressBtn={handleClose}
          width={"auto"}
          btnBgColor={"#fff"}
          btnTextColor={"gray"}
          isBorder={"1px solid #8692A6"}
          borderRadius={4}
        />
      )}
      {handleBtn && (
        <CustomButton
          btnLabel={btnLabel || "Save"}
          handlePressBtn={handleBtn}
          width={"auto"}
          variant={"webbutton"}
          borderRadius={3}
        />
      )}
    </DialogActions>
  );
};

export default DialogFooter;
